import styled from 'styled-components'

export const SidebarStyled = styled.div`
  background: ${({ theme }) => theme.colors.background};
  grid-area: sidebar;
  display: grid;
  grid-template-areas: 'sidebar-header' 'sidebar-content' 'sidebar-footer';
  grid-template-rows: auto 1fr auto;
  height: 100vh;

  .header {
    border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLighter};
    padding: 10px 0;
    margin: 10px;
    margin-bottom: 30px;

    h1 {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }

  .content {
    overflow-y: auto;
  }

  .footer {
    grid-area: sidebar-footer;
    display: grid;
    margin: 10px;

    .download-btn {
      .icon {
        margin-right: 0.5rem;
      }
    }
  }

  @media only screen and (max-width: ${({ theme }) => theme.responsive.small}) {
    .header {
      display: none;
    }

    .content {
      padding-top: 3rem;
      overflow-x: hidden;
    }

    .footer {
      margin: 0;

      .download-btn {
        padding: 10px 0;
        margin: 4px;
        border-radius: 2rem;

        .icon {
          margin: 0;
        }

        label {
          display: none;
        }
      }
    }
  }
`
